import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Modal, Table } from "react-bootstrap";
import QRCode from "qrcode.react";
import "../invoies.css";
import logo4b from "../../../image/logo_main.png";
import { Watermark } from "@hirohe/react-watermark";
import html2canvas from "html2canvas";
import { saveAs } from "file-saver";
import { COLOR_APP, S3_URL } from "../../../constants";
import { FaFileDownload } from "react-icons/fa";
import { AiOutlineClose } from "react-icons/ai";
import { HiSwitchHorizontal } from "react-icons/hi";
import { MdCancelScheduleSend, MdClose } from "react-icons/md";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCancel } from "@fortawesome/free-solid-svg-icons";
// import { QRCode } from "antd";

const STATUS_MAPPING = {
  WAITING: { color: "gray", text: "ລໍຖ້າຖອນເງິນ" },
  REQUEST: { color: "orange", text: "ລໍຖ້າຢືນຢັນ" },
  REJECT: { color: "red", text: "ຖືກປະຕິເສດ" },
  APPROVED: { color: "green", text: "ຢືນຢັນແລ້ວ" },
};

function InvoiceDetail({
  invoiceDetail,
  handleClose,
  bankData,
  handleRejectStatus,
}) {
  const detail = invoiceDetail?.data;
  const [bankShop, setBankShop] = useState()

  const sumPriceBahtAll = detail?.orderGroups.reduce(
    (total, order) => total + (order.sumPriceBaht || 0),
    0
  );
  const sumPriceUsdAll = detail?.orderGroups.reduce(
    (total, order) => total + (order.sumPriceUsd || 0),
    0
  );

  useEffect(() => {
    if (bankData?.banks?.data) {
      const activeBanks = bankData?.banks?.data?.filter(bank => bank?.isActiveDefault === true);
      setBankShop(activeBanks[0]);
    }
  }, [bankData]);
  

  // console.log("detailData77777=====>", detail);
  // console.log("sumPriceBaht8888=====>", sumPriceBahtAll, sumPriceUsdAll)

  const status = STATUS_MAPPING[detail?.status] || STATUS_MAPPING["WAITING"];

  const waterPhone = detail?.shop?.phone;
  const waterInvoiceNumber = detail?.invoiceNubmer;
  const converter = waterPhone + "\n" + waterInvoiceNumber;

  const captureElementRef = useRef(null);
  const [showModalBank, setShowModalBank] = useState(false);
  const [totalMoneyAffiliate, setTotalMoneyAffiliate] = useState();

  const handleCloseModalBank = () => setShowModalBank(false);
  const handleShowModalBank = () => setShowModalBank(true);

  const [selectedBank, setSelectedBank] = useState([]);

  useEffect(() => {
    const _sumPriceAffiliate = detail?.orderGroups.reduce(
      (total, order) => total + ((order.totalPrice * order?.infulancer_percent / 100) || 0),
      0
    );
    setTotalMoneyAffiliate(_sumPriceAffiliate || 0)
  }, [detail]);

  // Define your handleConfirm function
  const handleConfirm = () => {
    console.log("Selected Bank Data:", selectedBank);
  };

  const handleCaptureAndDownload = () => {
    if (captureElementRef.current) {
      html2canvas(captureElementRef.current).then((canvas) => {
        // Convert the canvas to a data URL
        const dataURL = canvas.toDataURL("image/jpeg");

        // Create a Blob from the data URL
        const blob = dataURLtoBlob(dataURL);

        // Save the Blob as a file
        saveAs(blob, "ໃບບິນແຈ້ງຖອນເງິນ.jpg");
      });
    }
  };

  // Function to convert data URL to Blob
  function dataURLtoBlob(dataURL) {
    const byteString = atob(dataURL.split(",")[1]);
    const mimeString = dataURL.split(",")[0].split(":")[1].split(";")[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);

    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ab], { type: mimeString });
  }

  return (
    <div>
      <Modal size="xl" show={invoiceDetail?.show}>

        <Modal.Body style={{ background: "#fdf5f5" }}>
          <div ref={captureElementRef} className="card-detail-fly">
            <Watermark text={converter}>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                <div className="img4B">
                  <img src={logo4b} alt="4bLOGO" />
                </div>
                <h1 style={{ textAlign: "center", fontWeight: "bold" }}>
                  ໃບແຈ້ງຖອນເງິນ
                </h1>
              </div>
              <div className="card-header-invoices">
                <div className="logo-4b">
                  <div className="d-flex justify-content-start align-items-center flex-column">
                    <img src={S3_URL + detail?.shop?.image} alt={detail?.shop?.name} style={{ maxWidth: 75 }} />
                    <h5>{detail?.shop?.name || "-"}</h5>
                    <p style={{ marginTop: '-.65em' }}>{detail?.shop?.phone || "-"}</p>
                  </div>
                </div>
                <div
                  style={{
                    lineHeight: "10px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "end",
                  }}>
                  <div style={{ display: "flex", justifyContent: "end" }}>
                    <p style={{ color: "gray" }}>ວັນທີແຈ້ງຖອນ</p>
                  </div>
                  <div style={{ display: "flex", justifyContent: "end" }}>
                    <p>
                      {moment(detail?.createdAt).format("DD/MM/YYYY HH:mm")}
                    </p>
                  </div>
                  <div style={{ display: "flex", justifyContent: "end" }}>
                    <p style={{ color: "gray" }}>ເລກທີບິນ</p>
                  </div>
                  <div style={{ display: "flex", justifyContent: "end" }}>
                    <p>{detail?.invoiceNubmer || "-"}</p>
                  </div>
                  {/* <div style={{ display: "flex", justifyContent: "start" }}>
                <p style={{ color: "gray" }}>ສະຖານະ: &nbsp;</p>
                <p style={{ color: status.color }}>{status.text}</p>
              </div> */}
                </div>
              </div>

              <Table style={{ position: "relative" }}>
                <div className="logoBusness">
                  <img src={logo4b} alt="4bLOGO" />
                </div>
                <thead>
                  <tr>
                    <th style={{ borderBottom: "1px solid #eeeeee" }}>#</th>
                    <th style={{ borderBottom: "1px solid #eeeeee" }}>
                      ເລກທີບິນສັ່ງຊື້
                    </th>
                    <th style={{ borderBottom: "1px solid #eeeeee" }}>
                      ຊື່ລູກຄ້າ
                    </th>
                    <th style={{ borderBottom: "1px solid #eeeeee" }}>
                      ເບີໂທລູກຄ້າ
                    </th>
                    <th style={{ borderBottom: "1px solid #eeeeee" }}>
                      ວັນທີສັ່ງຊື້
                    </th>
                    <th style={{ borderBottom: "1px solid #eeeeee" }}>
                      % Affiliate
                    </th>
                    <th style={{ borderBottom: "1px solid #eeeeee" }}>ກີບ</th>
                    <th style={{ borderBottom: "1px solid #eeeeee" }}>ບາດ</th>
                    <th style={{ borderBottom: "1px solid #eeeeee" }}>ໂດລາ</th>
                  </tr>
                </thead>
                <tbody>
                  {detail?.orderGroups?.map((item, index) => (
                    <tr key={item?.id}>
                      <td>{index + 1}</td>
                      <td>{item?.code}</td>
                      <td>{item?.customerName}</td>
                      <td>{item?.phone}</td>
                      <td>
                        {moment(item?.createdAt).format("DD/MM/YYYY HH:mm")}
                      </td>
                      <td>
                        % {" "}
                        {new Intl.NumberFormat("en-US").format(
                          item?.infulancer_percent
                        )}
                      </td>
                      <td>
                        ₭{" "}
                        {new Intl.NumberFormat("en-US").format(
                          item?.totalPrice
                        )}
                      </td>
                      <td>
                        ฿{" "}
                        {new Intl.NumberFormat("en-US").format(
                          item?.sumPriceBaht
                        )}
                      </td>
                      <td>
                        ${" "}
                        {new Intl.NumberFormat("en-US").format(
                          item?.sumPriceUsd
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  width: "100%",
                }}>
                <div className="main-banks-for-shop">
                  <div className="qrcode-bank">
                    <img
                      src={S3_URL + bankShop?.image}
                      style={{
                        // borderRadius: 8,
                        height: "100%",
                        width: "100%",
                      }}
                      alt="bankImage"
                    />
                    {/* <div className="center-icon">
                      <img src={logo4b} alt="icon" />
                    </div> */}
                    {/* <QRCode
                      value={bankShop?.bankAccount}
                      style={{ width: "100%", height: "100%" }}
                    /> */}
                    <span>qrCode ຮ້ານ</span>
                  </div>
                  <div className="name-bank">
                    <p>ທະນາຄານ: {bankShop?.bankName} </p>
                    <p>ຊື່ບັນຊີຮ້ານ: {bankShop?.bankUser} </p>
                    <p>ເລກບັນຊີ: {bankShop?.bankAccount}</p>
                  </div>
                </div>
                <div
                  style={{
                    lineHeight: "10px",
                    width: "40%",
                    marginTop: "1em",
                  }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}>
                    <p>ລວມເປັນກີບທັງໝົດ:</p>
                    <p>
                      ₭{" "}
                      {new Intl.NumberFormat("en-US").format(
                        detail?.totalMoney
                      )}
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}>
                    <p>ລວມເງິນບາດທັງໝົດ:</p>
                    <p>
                      ฿ {new Intl.NumberFormat("en-US").format(sumPriceBahtAll)}
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}>
                    <p>ລວມເງິນໂດລາທັງໝົດ:</p>
                    <p>
                      $ {new Intl.NumberFormat("en-US").format(sumPriceUsdAll)}
                    </p>
                  </div>
                  <hr />
                  {invoiceDetail?.type !== "LIVE_INVOICE" &&
                    <>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}>
                        <h5 style={{ fontWeight: "bold" }}>ຄ່າບໍລິການ 3%:</h5>
                        <h5 style={{ fontWeight: "bold" }}>
                          ₭{" "}
                          {new Intl.NumberFormat("en-US").format(
                            detail?.totalMoney * (detail?.percent / 100)
                          )}
                        </h5>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <h5 style={{ fontWeight: "bold" }}>ຄ່າບໍລິການໃຫ້ Affiliate:</h5>
                        <h5 style={{ fontWeight: "bold" }}>
                          ₭{" "}
                          {new Intl.NumberFormat("en-US").format(totalMoneyAffiliate)}
                        </h5>
                      </div>
                    </>}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "-.2em",
                    }}>
                    <h5 style={{ fontWeight: "bold" }}>ເງິນໄດ້ຮັບຕົວຈິງ:</h5>
                    {invoiceDetail?.type !== "LIVE_INVOICE" ?
                      <h5 style={{ fontWeight: "bold" }}>
                        ₭{" "}
                        {new Intl.NumberFormat("en-US").format(
                          detail?.totalMoney -
                          detail?.totalMoney * (detail?.percent / 100) - totalMoneyAffiliate
                        )}
                      </h5>
                      : <h5 style={{ fontWeight: "bold" }}>
                        ₭{" "}
                        {new Intl.NumberFormat("en-US").format(detail?.totalMoney)}
                      </h5>}
                  </div>
                </div>
              </div>
              <br></br>
              <p style={{ textAlign: "center", color: "gray" }}>
                ຂໍຂອບໃຈສຳລັບການໃຊ້ບໍລິການຂອງພວກເຮົາ
              </p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "start",
                  flexDirection: "column",
                  borderTop: "1px solid #ddd",
                  paddingTop: ".7em",
                }}>
                <small>ບໍລິສັດ: Lailaolab ICT Solutions CO.,LTD</small>
                {/* <small>ຊື່ແບຣນ: 4B ໂຟບີ - For Business</small>
                <small>ເພຈ: 4B ໂຟບີ - For Business</small>
                <small>ຕິກຕ໋ອກ: 4B ໂຟບີ - For Business</small> */}
              </div>
              <small>
                ເບີໂທຕິດຕໍ່ 020 98 962 978, ອີເມວ info@bbbb.com, ເວບໄຊ{" "}
                <a href="https://wwww.bbbb.com.la">
                  https://www.bbbb.com.la
                </a>
              </small>
            </Watermark>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              gap: "1em",
              width: "100%",
            }}>
            <Button variant="light" onClick={handleClose}>
              <MdClose /> ປີດໜ້ານີ້
            </Button>
            {detail?.status === "REQUEST" ? (
              <Button
                onClick={() => handleRejectStatus(detail?.id)}
                variant="outline-danger">
                <FontAwesomeIcon icon={faCancel} /> ຍົກເລີກແຈ້ງຖອນ
              </Button>
            ) : (
              ""
            )}

            <Button
              onClick={handleCaptureAndDownload}
              style={{ background: COLOR_APP, color: "white" }}>
              <FaFileDownload /> ດາວໂຫລດບິນ
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* start modal select banks */}
      <Modal
        show={showModalBank}
        centered
        onHide={handleCloseModalBank}
        style={{ position: "absolute", zIndex: 9999 }}>
        <Modal.Body>
          <div className="card-switch-banks">
            <Form.Label>ບັນຊີທະນາຄານ</Form.Label>
            <Form.Select
              aria-label="Default select example"
              onChange={(e) => setSelectedBank(e?.target?.value)}
              value={selectedBank}>
              <option>--ເລືອກ--</option>
              {bankData?.banks?.data?.map((name, index) => {
                return (
                  <option key={index} value={name}>
                    {name?.bankName}
                  </option>
                );
              })}
            </Form.Select>

            <div className="action-btn-confirm-bank">
              <Button
                variant="outline-secondary"
                onClick={handleCloseModalBank}>
                ຍົກເລິກ
              </Button>
              <Button
                onClick={handleConfirm}
                style={{ background: COLOR_APP, color: "white" }}>
                ຢືນຢັນ
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* end modal select banks */}
    </div>
  );
}

export default InvoiceDetail;
